module.exports = __webpack_public_path__ + "img/empty-followings_red.6628bc23.svg";